import { AnalysisSVG } from '@components/icon/svg';
import { Box, Button, Card, Typography } from '@mui/material';
import SurveyShare from '../SurveyShare';
import React from 'react';

export default function NoResponse({ study }) {
  const [openShare, setOpenShare] = React.useState(false);

  const handleOpenSurveyShare = () => {
    setOpenShare(true);
  };

  return (
    <>
      <Box py={3} px={3} sx={{ height: 'calc(100vh - 120px)' }}>
        <Card
          variant="outlined"
          sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
              textAlign: 'center',
            }}
          >
            <AnalysisSVG />
            <Box sx={{ mt: 2, textAlign: 'center' }}>
              <Typography mb={1} variant="h6">
                This study doesn’t have any responses yet
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Collect responses and analysis will show up here.{' '}
              </Typography>
            </Box>
            <Button variant="contained" size="large" sx={{ mt: 2 }} onClick={handleOpenSurveyShare}>
              Share Study
            </Button>
          </Box>
        </Card>
      </Box>
      <SurveyShare
        study_link={study?.short_url || study?.survey_access_url || study?.study_link}
        qr_code_url={study?.qr_code_url}
        open={openShare}
        hideSendToAI={study?.study_link ? true : false}
        handleClose={() => setOpenShare(false)}
        studyId={study?.id}
      />
    </>
  );
}
